export default __webpack_public_path__ + "static/media/d7ef9e34405fb663e32650647215ff51.svg";